import React from 'react';

export const DisplayPerType = ({ children, type, typeList }) => {
  return <>{typeList.find((item) => item.relatedToId === type) && children}</>;
};
